import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  savedChanges: {
    color: colors.green[600],
  },
  savingStatusWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontWeight: 400,
    textTransform: 'capitalize',
  },
  savingStatus: {
    fontSize: '1.6rem',
    paddingLeft: '0.4rem',
    lineHeight: '2.4rem',
    margin: '1rem 0',
  },
  savingInProcess: {
    color: colors.blue[600],
  },
  failedSaving: {
    color: colors.orange[600],
  },
  resaveBtn: {
    fontSize: '1.6rem',
    fontWeight: '700',
    textDecoration: 'underline',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
